import React, { createContext, useContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Kanban } from 'libs/kanban';

const KanbanContext = createContext(null);

export const KanbanProvider = ({ children, kanbanName, accountId }) => {
  const [filters, setFilters] = useState({});
  const [hiddenColumns, setHiddenColumns] = useState([]);
  const [item, setItem] = useState(null);
  const [accountSettings, setAccountSettings] = useState(null);
  const [columnId, setColumnId] = useState(null);

  const kanban = useMemo(() => {
    if (!kanbanName) return null;
    return new Kanban(kanbanName, accountId);
  }, [kanbanName, accountId]);

  const toggleColumn = (columnId) => {
    setHiddenColumns((prev) =>
      prev.includes(columnId) ? prev.filter((id) => id !== columnId) : [...prev, columnId],
    );
  };

  const value = {
    kanban,
    filters,
    setFilters,
    hiddenColumns,
    toggleColumn,
    item,
    setItem,
    accountSettings,
    setAccountSettings,
    columnId,
    setColumnId,
  };

  return <KanbanContext.Provider value={value}>{children}</KanbanContext.Provider>;
};

KanbanProvider.propTypes = {
  children: PropTypes.node.isRequired,
  kanbanName: PropTypes.string,
  accountId: PropTypes.string,
};

export const useKanban = () => {
  const context = useContext(KanbanContext);

  if (!context) {
    throw new Error('useKanban must be used within a KanbanProvider');
  }

  return context;
};
